import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65465586"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col mx-auto w-max" }
const _hoisted_2 = { class: "text-xl text-left" }
const _hoisted_3 = { class: "flex items-center my-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-sm" }, "STEP", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "step-img mb-0 mr-6" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex flex-col justify-between w-[200px] mt-2" }
const _hoisted_9 = { class: "text-lg mb-1.5" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "w-full flex my-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_connect_wallet = _resolveComponent("connect-wallet")!
  const _component_nomad_button = _resolveComponent("nomad-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: step.title,
            class: _normalizeClass(["py-1.5 px-2.5 mr-2 rounded-md bg-white text-white text-xs cursor-pointer", {
            'bg-[#ffffff33]': index <= _ctx.currentStep, // previous or current step
            'bg-[#ffffff1a]': index > _ctx.currentStep, // next step
          }]),
            onClick: ($event: any) => (_ctx.changeStep(index))
          }, _toDisplayString(index + 1), 11, _hoisted_5))
        }), 128))
      ]),
      _createVNode(_Transition, {
        name: _ctx.transitionType,
        mode: "out-in",
        appear: "",
        class: "mt-6 mb-4 w-full"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            class: "flex flex-col sm:flex-row",
            key: _ctx.currentStep
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.steps[_ctx.currentStep].img
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.steps[_ctx.currentStep].title), 1),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.steps[_ctx.currentStep].description) + " ", 1),
                  ((_ctx.steps[_ctx.currentStep].title === 'Go to CoinList'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.coinlistFaq,
                        class: "underline",
                        target: "_blank"
                      }, " FAQs. ", 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.currentStep === 0)
                  ? (_openBlock(), _createBlock(_component_connect_wallet, {
                      key: 0,
                      text: "Connect Wallet",
                      primary: "",
                      onConnected: _ctx.goToNextStep
                    }, null, 8, ["onConnected"]))
                  : (_ctx.userAllowed && _ctx.currentStep === 4)
                    ? (_openBlock(), _createBlock(_component_nomad_button, {
                        key: 1,
                        class: "next",
                        primary: "",
                        onClick: _ctx.toBridge
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Bridge Now ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (!_ctx.userAllowed && _ctx.currentStep === 3)
                      ? (_openBlock(), _createBlock(_component_nomad_button, {
                          key: 2,
                          class: "next",
                          primary: "",
                          onClick: _ctx.toCoinlistVerify
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" CoinList Verify+ ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_nomad_button, {
                          key: 3,
                          class: "next",
                          primary: "",
                          onClick: _ctx.goToNextStep
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Next > ")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
              ])
            ])
          ]))
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_component_nomad_button, {
        class: "mt-6",
        secondary: "",
        onClick: _ctx.toRecoveryLink
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Read about the recovery process ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}